import { createSelector } from '@reduxjs/toolkit';
import { DefaultEmptyAddress } from '@/types/Address';
import { getUserData } from '@/redux/modules/account/user/user.selectors';
import { translateAddressAccents } from '@/utils/address';

export const getProfileAddress = createSelector([getUserData], (userData) => {
    const defaultAddress =
        userData.addresses?.filter((address) => Boolean(address.isDefault))[0] || DefaultEmptyAddress;

    return translateAddressAccents({
        address: userData.address || '',
        address2: userData.address2 || '',
        city: userData.city || '',
        country: userData.country || '',
        firstName: userData.firstName || '',
        lastName: userData.lastName || '',
        mobileNumber: userData.mobileNumber || userData.phoneNumber || '',
        organizationName: defaultAddress?.organizationName || '',
        state: userData.state || '',
        zip: userData.zip || '',
    });
});
